// extracted by mini-css-extract-plugin
export default {"pagination":"tables-footer_pagination__2ACKS","footer":"tables-footer_footer__qgCDa","divider":"tables-footer_divider__fQRTp"};